/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Advantage_SupportInputs */

const en_plan_advantage_support = /** @type {(inputs: Plan_Advantage_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Priority email support`)
};

const es_plan_advantage_support = /** @type {(inputs: Plan_Advantage_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soporte prioritario por correo electrónico`)
};

/**
* | output |
* | --- |
* | "Priority email support" |
*
* @param {Plan_Advantage_SupportInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_advantage_support = /** @type {((inputs?: Plan_Advantage_SupportInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Advantage_SupportInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_advantage_support(inputs)
	return en_plan_advantage_support(inputs)
});